import script from "./SuspendedMemberOverlay.vue?vue&type=script&setup=true&lang=js"
export * from "./SuspendedMemberOverlay.vue?vue&type=script&setup=true&lang=js"

import "./SuspendedMemberOverlay.vue?vue&type=style&index=0&id=cdddce36&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cdddce36"]])

export default __exports__